
import React, { Component } from 'react';
import './add-section.scss'
import { Modal, ModalBody } from "reactstrap";

import SchoolApi from '../../../apis/school'
import { ImageConstants, Constants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import PillButton from '../../common/pill-button-select/pill-button-select'
import Dropdown from '../../common/dropdown-v2/dropdown';
import SessionCache from '../../routes/session-cache';


class AddContactComponent extends Component {
    constructor(props) {
        super(props)

    }

    state = {
        sections: [],
        tables: {},
        classHash: {},
        selectedClass: [],
        from: this.props.from
    }
    sectionsCount = Constants.SECTION_DROPDOWN
    sectionNames = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"]

    studentsCountHash = {}
    createdUserCount = 0
    user = {}
    sectionAdded = false

    componentDidMount() {
        let user = SessionCache.getUser()
        this.user = user
        this.getClassAndBoard()
    }

    getClassAndBoard(payload = {}) {
        SchoolApi.getClassAndBoard(payload)
            .then(school => {
                let classes = [], boards = [];
                for (let i = 0; i < school.classes.length; i++) {
                    classes.push({
                        title: school.classes[i].name,
                        value: school.classes[i].name,
                    })
                }

                for (let i = 0; i < school.boards.length; i++) {
                    boards.push({
                        title: school.boards[i].name,
                        value: school.boards[i].name,
                    })
                }

                let selectedBoard = ""
                if (boards.length == 1) {
                    selectedBoard = boards[0].value
                }


                this.setState({ selectedBoard, class: classes, board: boards })
            }).catch(err => {
            })
    }


    getSections(payload = {}) {

        payload = {
            class: this.state.selectedClass.join(","),
            board: this.state.selectedBoard
        }
        if (!payload.class || !payload.board) return

        SchoolApi.getSectionsList(payload)
            .then(response => {
                let sections = response.response
                let classHash = {}
                for (let i = 0; i < sections.length; i++) {
                    let section = sections[i]
                    let obj = {
                        id: section._id,
                        name: section.section,
                        teacherId: section.teacherId,
                        disabled: section.teacherId && section.teacherId != this.user?.id,
                        isAlreadyCreated: true
                    }
                    if (classHash[section.class]) {
                        classHash[section.class].push(obj)
                    } else {
                        classHash[section.class] = [obj]
                    }
                }

                this.setState({ classHash })
            }).catch(err => {
                this.setState({ classHash: {} })
            })
    }


    onSelectClass = (option) => {
        option.sort()
        let tables = this.state.tables
        let newTables = {}
        for (let i = 0; i < option.length; i++) {
            let obj = tables[option[i]]
            if (obj) newTables[option[i]] = obj
        }
        this.setState({ selectedClass: option, tables: newTables }, () => {
            this.getSections()
        })
    }

    onSelectBoard = (option) => {
        this.setState({ selectedBoard: option, reloadDropdown: true }, () => {
            this.resetTable()
            this.getSections()
            this.setState({ reloadDropdown: false })
        })
    }


    onSelectSectionNumber = (option, className) => {

        let sections = []
        for (let i = 0; i < option?.value; i++) {
            let classDetails = this.state.classHash[className]
            if (classDetails && classDetails[i]) {
                sections.push(classDetails[i])
            } else {
                sections.push({ name: this.sectionNames[i] })

            }
        }

        let tables = this.state.tables
        if (!sections.length) {
            delete tables[className]
        } else {
            tables[className] = sections
        }
        this.setState({ tables }, () => {
            this.validateForm()
        })

    }

    prepareSectionHeader(tableKeys) {
        let tables = this.state.tables
        let sectionLength = 0
        for (let i = 0; i < tableKeys.length; i++) {
            let len = tables[tableKeys[i]].length
            if (sectionLength < len) {
                sectionLength = len
            }
        }
        let headers = []
        for (let i = 0; i < sectionLength; i++) {
            headers.push(`Section ${i + 1}`)
        }
        return headers
    }

    onChangeTableValue = (event, className, index) => {
        let tables = this.state.tables
        tables[className][index].name = event.target.value
        this.setState({ tables })
    }

    onClickTick(className, index) {
        let tables = this.state.tables
        tables[className][index].teacherId = tables[className][index].teacherId ? null : this.user.id
        this.setState({ tables })
    }

    resetTable() {
        this.setState({ tables: {} }, () => {
            this.validateForm()
        })
    }

    validateForm() {
        let table = Object.keys(this.state.tables)
        if (table && table.length) {
            this.setState({ enableContinue: true })
        } else {
            this.setState({ enableContinue: false })
        }
    }

    preparePayload() {

        let tables = Object.keys(this.state.tables)
        let updatePayload = []
        let createPayload = []
        tables.forEach(element => {
            let data = this.state.tables[element]
            data.forEach((item, index) => {
                if (!item.disabled) {
                    let payload = {
                        class: element,
                        board: this.state.selectedBoard,
                        teacherId: item.teacherId,
                        name: item.name,
                        order: index + 1
                    }
                    if (!this.sectionAdded) this.sectionAdded = item.teacherId == this.user.id
                    if (item.isAlreadyCreated) {
                        if (payload.teacherId) {
                            payload.id = item.id
                            updatePayload.push(payload)
                        }
                    } else {
                        createPayload.push(payload)
                    }
                }
            })
        })
        return {
            createPayload,
            updatePayload
        }
    }

    onClickContinue() {
        let payload = this.preparePayload()

        if (!payload.createPayload?.length && !payload.updatePayload?.length) {
            this.props.onClose && this.props.onClose()
            return
        }
        SchoolApi.createSectionByTeacher(payload)
            .then(staffs => {
                if (this.sectionAdded) {
                    let user = SessionCache.getUser()
                    user.schoolInfo.totalSections = 1
                    SessionCache.setUser(user)
                }
                this.props.onClose && this.props.onClose(true)
            }).catch(err => {
            })

    }

    renderTableRow(tableKey) {

        let arr = [
            <td className="veritical-align">{tableKey}</td>
        ]
        let tableData = this.state.tables[tableKey]
        for (let i = 0; i < tableData.length; i++) {
            let item = tableData[i]
            arr.push(
                <td className="veritical-align">
                    <div>
                        {
                            !item.isAlreadyCreated ?
                                <input value={item.name} onChange={event => this.onChangeTableValue(event, tableKey, i)} />
                                :
                                <span className="not-editable">{item.name} </span>
                        }

                        {
                            this.state.from != "STUDENTS" ?
                                <span className="cursor-pointer" onClick={() => !item.disabled ? this.onClickTick(tableKey, i) : ""}>
                                    {
                                        item.teacherId == this.user.id ?
                                            <img className="tick-mark float-right" src={getImageSource(ImageConstants.TICK)} />
                                            :
                                            <img className="tick-mark float-right" src={getImageSource(ImageConstants.TICK_GRAY)} />

                                    }
                                </span> : ""
                        }
                    </div>
                    {
                        item.disabled && this.state.from != "STUDENTS" ?
                            <div class="text-center">
                                <span className="teacher-assigned">Another Teacher Assigned</span>
                            </div>
                            : ""
                    }
                </td>
            )
        }
        return arr
    }

    renderTables() {
        let tableKeys = Object.keys(this.state.tables)
        let headers = this.prepareSectionHeader(tableKeys) || []
        if (tableKeys.length) {
            return (
                <div className="mt-2">
                    <div className="text-semi-bold">UPDATE SECTIONS & SELECT SECTIONS YOU TEACH, IF ANY</div>
                    <div id="table-scoll" className="table-responsive pt-3">
                        <table className="table section-table">
                            <thead>
                                <tr className="text-center">
                                    <th className='th-left-radius'> </th>
                                    {
                                        headers.map(header => (
                                            <th> {header} </th>
                                        ))
                                    }
                                </tr>
                            </thead>
                            <tbody className="bg-white">
                                {
                                    tableKeys.map(item => (
                                        <tr className="mt-4 text-center" key={item}>
                                            {this.renderTableRow(item)}
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }
    }

    render() {
        let keys = Object.keys(this.state.tables)
        return (
            <Modal className="cw-custom-modal-right" isOpen={this.props.show} toggle={this.props.onClose} size={this.props.size || 'md'}>

                <ModalBody >
                    <div className="add-dashboard-section">
                        <div>
                            <div className="abs-image">
                                <img className='cursor-pointer header-image' src={getImageSource(ImageConstants.HEADER1)} />
                            </div>

                            <div className="pt-4 my-auto">
                                {this.props.step ? <span className="step-title">STEP {this.props.step}</span> : ""}
                                <span className="float-right">
                                    <img className='close-icon cursor-pointer' src={getImageSource(ImageConstants.CROSS)} onClick={this.props.onClose} />
                                </span>
                            </div>

                            <div className="pt-4 my-auto">
                                <span className="header-title">ADD SECTION</span>
                            </div>

                            <div>
                                {
                                    this.state.board?.length > 1 && <div className='pt-4'>
                                        <PillButton key={'board'} value={this.state.selectedBoard} options={this.state.board} onSelect={this.onSelectBoard} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                                    </div>
                                }
                                {
                                    this.state.selectedBoard ?
                                        <div className='pt-4'>
                                            <PillButton key={'classes'} isMultiple value={this.state.selectedClass} options={this.state.class} onSelect={this.onSelectClass} size={'md'} style={{ fontSize: 17, fontWeight: 'bold' }} />
                                        </div>
                                        : ""
                                }
                            </div>
                            <div className="pt-4">
                                {
                                    !this.state.reloadDropdown ? this.state.selectedClass?.map(item => (

                                        <div className='d-inline-block section-dropdown'>
                                            <Dropdown
                                                placeholder='No. of Sections'
                                                options={this.sectionsCount}
                                                onSelect={(option) => this.onSelectSectionNumber(option, item)}
                                                style={{ background: "#F6F7F5" }}
                                                text={"title"}
                                                value={this.state.numberOfSections}
                                            />
                                        </div>
                                    )) : ""
                                }
                            </div>

                            <div className="pt-4">
                                {
                                    this.renderTables()
                                }
                            </div>

                            <div className="mt-4">{
                                keys.length ?
                                    <span className="note p-3">
                                        <img className="bulb-img" src={getImageSource(ImageConstants.BULB)} />
                                        <span className="pl-2 ">
                                            Click on section to update it as per your school
                                        </span>
                                    </span> : ""}
                            </div>
                            {
                                keys.length ?
                                    <div className="footer">
                                        <button className={`cw-button-primary ${!this.state.enableContinue ? "disable-button" : ""}`} onClick={() => this.state.enableContinue ? this.onClickContinue() : ""}>
                                            {"CONTINUE"}
                                        </button>
                                    </div> : ""
                            }
                        </div>
                    </div>
                </ModalBody>

            </Modal >
        );
    }
}

export default AddContactComponent;